import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'pc-flex-col-grow',
  imports: [],
  templateUrl: './pc-flex-col-grow.component.html',
  styleUrl: './pc-flex-col-grow.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PcFlexColGrowComponent {}
